import { Component, OnInit, Input } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl
} from '@angular/forms';
import { Rol } from '@core/model/rol.model';
import { User } from '@core/model/user.model';
import { UserService } from '@app/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-usuario-create',
  templateUrl: './usuario-create.component.html',
  styleUrls: ['./usuario-create.component.css']
})
export class UsuarioCreateComponent implements OnInit {
  userForm: FormGroup;
  roles2: Rol[];
  users: User[];
  selectedRols: any[];
  usuario: any = {};
  @Input() roles3: any;
  @Input() user: any;
  @Input() flag: boolean;
  isLoading = false;
  rolesCtrl: FormArray;
  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService,
    public activeModal: NgbActiveModal
  ) {
    this.selectedRols = new Array();

    // this.roles2 = new Array();
  }

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.userForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      nombres: ['', Validators.required],
      apellidos: ['', Validators.required],
      ci: ['', Validators.required],
      celular: ['', Validators.required],
      roles: this.buildRoles()
    });

    // this.addCheckboxes();
  }

  get roles(): FormArray {
    return this.userForm.get('roles') as FormArray;
  }

  buildRoles() {
    const arr = this.roles3.map((rol: any) => {
      return this.formBuilder.control(rol.enabled);
    });

    console.log(arr);
    return this.formBuilder.array(arr);
  }

  registerUser(userForm: any) {
    const formValue = Object.assign({}, userForm, {
      roles: userForm.roles.map((selected: any, i: number) => {
        return {
          id: this.roles3[i].id,
          enabled: selected
        };
      })
    });

    this.userService.create(formValue).subscribe(
      data => {
        alert('el usuario fue creado satisfactoriamente');

        this.activeModal.close(data);
      },
      (error: any) => {
        alert('error');
      }
    );
    console.log(userForm);
  }

  editarUsuario(id: string) {
    alert(id);
    this.userService.getById(id).subscribe(
      data => {
        //   console.log(data);

        this.userForm.setValue({
          username: data.username,
          password: '',
          email: data.email,
          nombres: data.nombres,
          apellidos: data.apellidos,
          ci: data.ci,
          celular: data.celular
          //  role: this.rolesList(data.roles)
        });
      },
      error1 => console.log(error1)
    );
  }
}
